<template>
  <div>
    <table-view
      ref="tableList1"
      :tableModel="tableModel1"
      :tableData="externalTableData"
      :pages="pages1"
      tableCardTitle="External Evaluation"
      class="mt-24"
      v-if="false"
    >
      <template v-slot:action="{ tableRow }">
        <a href="javascript:void(0)" @click="handleEditBtn(tableRow.row)">
          <span class="icon-pencil1" style="color: #3a3f63" />
        </a>
      </template>
      <!--      <template v-slot:rating="{ tableRow }">-->
      <!--        <a href="javascript:void(0)" @click="handleCalcBtn(tableRow.row)">-->
      <!--          {{-->
      <!--            tableRow.row.globalCustomerRating == null-->
      <!--              ? 'Calculate'-->
      <!--              : tableRow.row.globalCustomerRating-->
      <!--          }}-->
      <!--        </a>-->
      <!--      </template>-->
    </table-view>

    <table-view
      ref="tableList2"
      :tableModel="tableModel2"
      :tableData="internalTableData"
      :pages="pages2"
      tableCardTitle="Internal Evaluation"
    >
      <template v-slot:rating="{ tableRow }">
        <a href="javascript:void(0)" @click="handleCalcBtn(tableRow.row)">
          {{
            tableRow.row.globalCustomerRating === null
              ? 'Calculate'
              : tableRow.row.globalCustomerRating
          }}
        </a>
      </template>
    </table-view>

    <el-dialog
      title="Calculate"
      :visible.sync="visible"
      width="446px"
      @close="handleClose"
      :close-on-click-modal="false"
    >
      <el-card shadow="never">
        <el-form ref="form" label-position="top" :model="form" :rules="rules">
          <el-form-item label="Data Source" prop="dataSource">
            <el-select v-model="form.dataSource" style="width: 100%">
              <el-option label="Public Rating Agency" :value="1" />
              <el-option label="Financial Report" :value="2" />
            </el-select>
          </el-form-item>
          <el-form-item
            v-if="form.dataSource === 2"
            label="Business Type"
            prop="businessType"
          >
            <el-select v-model="form.businessType" style="width: 100%">
              <el-option label="DS" :value="1" />
              <el-option label="BP" :value="2" />
            </el-select>
          </el-form-item>
        </el-form>
      </el-card>
      <div slot="footer">
        <customize-button @click="visible = false" style="margin-right: 14px">
          Cancel
        </customize-button>
        <customize-button type="primary" @click="handleClickGcrBtn">
          Confirm
        </customize-button>
      </div>
    </el-dialog>
    <el-dialog
      title="Edit"
      :visible.sync="visible2"
      width="952px"
      @close="handleClose(1)"
      :close-on-click-modal="false"
    >
      <el-card shadow="never">
        <el-form
          ref="form2"
          label-suffix=":"
          :inline="true"
          :model="form2"
          :rules="rules"
        >
          <div class="content-wrapper">
            <el-form-item label="Global Customer Rating">
              {{ globalCustomerRating }}
            </el-form-item>
            <el-form-item
              label="Effective Global Customer Rating"
              prop="effectiveGlobalCustomerRating"
            >
              <el-input v-model="form2.effectiveGlobalCustomerRating" />
            </el-form-item>
          </div>
          <el-form-item label="Remark" prop="reducedRemark">
            <el-input
              style="width: 836px"
              type="textarea"
              :rows="4"
              v-model="form2.reducedRemark"
            />
          </el-form-item>
        </el-form>
        <customize-button type="primary" @click="handleSaveBtn">
          Confirm
        </customize-button>
        <table-view
          class="dialog"
          ref="tableList3"
          :tableModel="tableModel3"
          :tableData="tableData3"
          :pages="pages3"
        />
      </el-card>
    </el-dialog>
  </div>
</template>

<script>
import {
  getExternalTableData,
  getInternalTableData,
  saveGcr,
  getDialogTableData,
  saveDialogForm,
} from './api'

export default {
  data() {
    const tableModel1 = [
      {
        label: 'Year',
        prop: 'time',
      },
      {
        label: 'Frisk',
        prop: 'frisk',
      },
      // {
      //   label: 'Global Customer Rating',
      //   slotName: 'rating',
      // },
      // {
      //   width: '120',
      //   label: 'Action',
      //   slotName: 'action',
      // },
    ]
    const tableModel2 = [
      {
        label: 'Year',
        prop: 'time',
      },
      {
        label: 'Z-Score',
        prop: 'zscore',
      },
      {
        label: "Z'-Score",
        prop: 'zscoreSecond',
      },
      {
        label: 'Scorecard',
        prop: 'scoreCard',
      },
      {
        width: 180,
        label: 'Theoretical Limit (USD)',
        prop: 'theoreticalLimit',
      },
      // {
      //   label: 'Currency',
      //   prop: 'currency',
      // },
      {
        width: 200,
        label: 'GCR Matrix',
        slotName: 'rating',
      },
    ]
    const tableModel3 = [
      {
        label: 'F-Risk',
        prop: 'frisk',
      },
      {
        label: 'Remark',
        prop: 'remark',
      },
      {
        label: 'Modified by',
        prop: 'operator',
      },
    ]
    return {
      tableModel1: tableModel1,
      tableModel2: tableModel2,
      tableModel3: tableModel3,
      externalTableData: [],
      internalTableData: [],
      tableData3: [],
      pages1: {},
      pages2: {},
      pages3: {},
      visible: false,
      visible2: false,
      form: { dataSource: '', businessType: '' },
      form2: { effectiveGlobalCustomerRating: '', reducedRemark: '' },
      rules: {
        dataSource: [
          { required: true, message: 'Can not be empty!', trigger: 'change' },
        ],
        businessType: [
          { required: true, message: 'Can not be empty!', trigger: 'change' },
        ],
      },
      globalCustomerRating: '',
    }
  },
  mounted() {
    this.companyId = this.$route.params.customerId
    // this.initExternalTable()
    this.initInternalTable()
  },
  methods: {
    handleEditBtn(res) {
      this.globalCustomerRating = res.globalCustomerRating
      this.visible2 = true
      this.form2Id = res.id
      this.$nextTick(() => {
        this._getDialogTableData(res.id)
      })
    },
    async _getDialogTableData(id) {
      try {
        const params = this.$refs.tableList3.getSearchData()
        const { data, page } = await getDialogTableData({
          ...params,
          id,
        })
        this.tableData3 = data
        this.pages3 = page
      } catch (err) {
        console.error(err)
      }
    },
    async handleSaveBtn() {
      try {
        await saveDialogForm({ ...this.form2, id: this.form2Id })
        this.$message.success('success')
        this.visible2 = false
      } catch (err) {
        console.error(err)
      }
    },
    handleCalcBtn({ id }) {
      this.gcrId = id
      this.visible = true
    },
    async handleClickGcrBtn() {
      const valid = await this.$refs.form.validate()
      if (!valid) return false
      try {
        await saveGcr({
          ...this.form,
          companyId: this.companyId,
          id: this.gcrId,
        })
        this.initInternalTable()
        this.$message.success('success')
        this.visible = false
      } catch (err) {
        console.error(err)
      }
    },
    initExternalTable() {
      const params = this.$refs.tableList1.getSearchData()
      this._getExternalTableData({ ...params, companyId: this.companyId })
    },
    async _getExternalTableData(params) {
      try {
        const { data, page } = await getExternalTableData(params)
        this.externalTableData = data
        this.pages1 = page
      } catch (err) {
        console.error(err)
      }
    },
    initInternalTable() {
      const params = this.$refs.tableList2.getSearchData()
      this._getInternalTableData({ ...params, companyId: this.companyId })
    },
    async _getInternalTableData(params) {
      try {
        const { data, page } = await getInternalTableData(params)
        this.internalTableData = data
        this.internalTableData.map(item => {
          var regPos = /^\d+(\.\d+)?$/
          var regNeg =
            /^(-(([0-9]+\.[0-9]*[1-9][0-9]*)|([0-9]*[1-9][0-9]*\.[0-9]+)|([0-9]*[1-9][0-9]*)))$/
          if (
            regPos.test(item.theoreticalLimit) ||
            regNeg.test(item.theoreticalLimit)
          ) {
            item.theoreticalLimit = this.$utils.formatAmount(
              item.theoreticalLimit,
            )
          } else {
            return item.theoreticalLimit
          }
        })
        this.pages2 = page
      } catch (err) {
        console.error(err)
      }
    },
    handleClose(flag) {
      if (flag) {
        this.$refs.form2.resetFields()
      } else {
        this.$refs.form.resetFields()
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.content-wrapper {
  width: 872px;
  display: flex;
  justify-content: space-between;
  .el-form-item {
    flex: 1;
  }
}

.dialog {
  :deep(.card) {
    padding: 0;
  }
}
</style>
